<template>
  <div
    :class="{
      'cover-mobile': $vuetify.breakpoint.width <= 625,
      cover: $vuetify.breakpoint.width > 625
    }"
  >
    <v-row class="mt-0 pt-7">
      <v-col>
        <v-row class="px-1 d-flex align-end">
          <v-col cols="6">
            <v-text-field
              single-line
              solo
              flat
              dense
              v-model="searchText"
              clearable
              :placeholder="'ค้นหา สถานที่,ถนน'"
              data-testid="searchInput"
              @change="$emit('filter', { searchText: searchText, typeSelect: typeSelect})"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="d-flex pl-0">
            <v-select
              solo
              flat
              dense
              v-model="typeSelect"
              :items="showType"
              item-text="text"
              item-value="value"
              data-testid="selectType"
              placeholder="ประเภท"
              @change="$emit('filter', { searchText: searchText, typeSelect: typeSelect})"
            >
              <template v-slot:selection="{ item }">
                <img
                  width="30"
                  height="30"
                  :src="require('@/assets/icon/' + item.icon)"
                /><span
                  class="pl-1"
                  style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
                  >{{ item.text }}</span
                >
              </template>
              <template
                v-slot:item="{ item }"
                class="d-flex justify-space-around"
              >
                <img
                  width="40"
                  height="40"
                  :src="require('@/assets/icon/' + item.icon)"
                /><span class="pl-1">{{ item.text }}</span>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'search',
  mounted () {},
  computed: {
    showType () {
      const result = []
      for (let index = 0; index < this.havetype.length; index++) {
        const element = this.havetype[index]
        const target = this.items.filter(item => item.value === element)
        if (target.length) {
          result.push(target[0])
        }
      }
      return result
    }
  },
  props: {
    havetype: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    clearSearch () {
      this.typeSelect = false
      this.searchText = ''
    }
  },
  data: () => ({
    typeSelect: false,
    searchText: '',
    items: [
      {
        text: 'บริษัทกลาง ฯ',
        icon: 'icon01.png',
        value: 'RVP'
      },
      {
        text: 'ตัวแทน บริการ พ.ร.บ.',
        icon: 'icon02.png',
        value: 'Insurance Agent'
      },
      {
        text: 'ธนาคาร ธกส.',
        icon: 'icon03.png',
        value: '3'
      },
      {
        text: 'เคาน์เตอร์เซอร์วิส',
        icon: 'icon04.png',
        value: '4'
      },
      {
        text: 'สถานตรวจสภาพรถเอกชน (ตรอ.)',
        icon: 'icon05.png',
        value: 'Vehicle Inspection Center'
      },
      {
        text: 'ร้านจักรยานยนต์',
        icon: 'icon06.png',
        value: 'Motorcycle dealers'
      },
      {
        text: 'โรงพยาบาล',
        icon: 'icon07.png',
        value: 'Hospital'
      },
      {
        text: 'สถานีตำรวจ',
        icon: 'icon08.png',
        value: '7'
      },
      {
        text: 'มูลนิธิ กู้ชีพ กู้ภัย',
        icon: 'icon09.png',
        value: '9'
      },
      {
        text: 'สถาบันการแพทย์ฉุกเฉินแห่งชาติ',
        icon: 'icon10.png',
        value: '10'
      }
    ]
  })
}
</script>

<style>
.cover-mobile {
  background-image: url("../assets/Banner_web_placervp.jpg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: contain;
  background-color: #6541df;
}
.cover {
  background-image: url("../assets/Banner_web_placervp.jpg");
  background-size: 100% 50%;
  background-color: #6541df;
}
</style>
